"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireWildcard"));

var _report = require("@/api/report");

var _builtRecycle = require("@/api/builtRecycle");

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "taskImport",
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      importDialogVisible: false,
      campaignList: [],
      importForm: {
        campaignId: ""
      },
      file: "",
      failDialogVisible: false,
      importResult: [],
      downloadLoading: false,
      rules: {
        campaignId: [{
          required: true,
          message: "任务名称不能为空",
          trigger: "blur"
        }]
      },
      listLoading: false,
      timeArray: [],
      listQuery: {
        startTime: '',
        endTime: '',
        page: 1,
        limit: 20,
        order: "desc"
      },
      list: [],
      total: 0
    };
  },
  computed: {},
  created: function created() {
    this.getTaskName();
  },
  methods: {
    getTaskName: function getTaskName() {
      var _this = this;

      (0, _report.taskImprt)({}).then(function (response) {
        _this.campaignList = response.data.data.list;
      }).catch(function (err) {
        console.log(err);
      });
    },
    importDialog: function importDialog() {
      if (this.file != "") {
        this.file = "";
        this.$refs.file.value = "";
      }

      this.importForm = {
        campaignId: "",
        channelId: ""
      };
      this.importDialogVisible = true;
    },
    //获取上传文件
    getFile: function getFile(event) {
      this.file = event.target.files[0];
      console.log(this.file);
    },
    importConfirm: function importConfirm() {
      var _this2 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          _this2.confUploadBtn();
        }
      });
    },
    getList: function getList() {
      var _this3 = this;

      if (this.timeArray && this.timeArray.length === 2) {
        this.listQuery.startTime = this.timeArray[0];
        this.listQuery.endTime = this.timeArray[1];
      } else {
        this.listQuery.startTime = null;
        this.listQuery.endTime = null;
      }

      this.listLoading = true;
      (0, _builtRecycle.importList)(this.listQuery).then(function (res) {
        _this3.list = res.data.data.list;
        _this3.total = res.data.data.total;
        _this3.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    confUploadBtn: function confUploadBtn() {
      var _this4 = this;

      if (this.file == "") {
        this.$message.warning("请选择文件！");
        return;
      }

      var loading = this.$loading({
        lock: true,
        text: "文件导入中，请耐心等待...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      var formData = new window.FormData(); // vue 中使用 window.FormData(),否则会报 'FormData isn't definded'

      formData.append("file", this.file);
      formData.append("campaignId", this.importForm.campaignId);
      (0, _builtRecycle.importTask)(formData).then(function (res) {
        console.log("导入返回数据", res);
        loading.close();

        _this4.$notify.warning({
          title: '提交成功',
          message: 'Excel提交成功，系统将分批次处理，具体结果请看列表'
        });

        _this4.importDialogVisible = false;

        _this4.getList();
      }).catch(function (err) {
        loading.close();

        _this4.$notify.warning({
          title: '警告',
          message: err.data.errmsg
        });
      });
    },
    handleDownload: function handleDownload() {
      var _this5 = this;

      this.downloadLoading = true;
      Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/vendor/Export2Excel'));
      }).then(function (excel) {
        var tHeader = ['导入结果', '导入备注', '手机号', '会员编号', '省', '市', '区', '注册来源', '注册时间', '宝宝性别（大宝）', '宝宝生日（大宝）', '宝宝性别（二宝）', '宝宝生日（二宝）', '订单编号', '订单来源', '门店编号', '订单时间', '订单金额', '订单状态', '产品名称', '产品编号', '产品数量', '产品码', '扫码时间', '累计积分'];
        var filterVal = ['importStatus', 'importRemark', 'mobile', 'memberNo', 'province', 'city', 'town', 'joinSource', 'joinDate', 'babySex1', 'babyBirthday1', 'babySex2', 'babyBirthday2', 'orderSn', 'orderChannel', 'shopNo', 'orderTime', 'payFee', 'orderStatus', 'productName', 'productNo', 'amount', 'productCode', 'scanTime', 'point'];
        excel.export_json_to_excel2(tHeader, _this5.importResult, filterVal, '对象存储信息');
        _this5.downloadLoading = false;
      });
    }
  }
};
exports.default = _default;